export default function DealerFinancePage() {
    return (
        <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-lg font-semibold mb-4">Dealer Finance</h2>
            <p className="text-sm text-gray-600">
                Manage dealer financing, floor plans, and transactions here.
            </p>
        </div>
    );
}
